/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bnb_greenfield_chain_about = () => `Positioned as the third blockchain within the BNB Chain ecosystem BNB Greenfield utilizes BNB as its native token.
		In essence, BNB Greenfield aims to offer decentralized storage infrastructure within the expansive BNB Chain ecosystem. This empowers users and dApps to generate, store, and exchange data while retaining full ownership. The potential outcome is the emergence of a new data-centric economy, enabling all participants within the BNB Chain ecosystem to possess, utilize, and monetize data.`
